import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    categoryId: String,
    isMobile: Boolean
  }
  static targets = ["icon"]

  connect() {
    if (!window.expandedCategoryIds) {
      window.expandedCategoryIds = new Set()
    }
    
    this.collapsed = !window.expandedCategoryIds.has(this.categoryIdValue)
    this.updateVisibility()
  }

  toggle(event) {
    if (event) {
      if (event.target.closest("a, button, input, select, textarea")) {
        return
      }
      event.preventDefault()
      event.stopPropagation()
    }
    this.collapsed = !this.collapsed
    
    if (this.collapsed) {
      window.expandedCategoryIds.delete(this.categoryIdValue)
    } else {
      window.expandedCategoryIds.add(this.categoryIdValue)
    }
    
    this.updateVisibility()
  }

  updateVisibility() {
    const selector = this.isMobileValue 
      ? `#mobile-task-rows [data-parent-id="${this.categoryIdValue}"]`
      : `#task-rows [data-parent-id="${this.categoryIdValue}"]`
      
    const subRows = document.querySelectorAll(selector)
    subRows.forEach(row => {
      if (this.collapsed) {
        row.classList.add("hidden")
      } else {
        row.classList.remove("hidden")
      }
    })

    if (this.hasIconTarget) {
      if (this.collapsed) {
        this.iconTarget.classList.remove("rotate-90")
      } else {
        this.iconTarget.classList.add("rotate-90")
      }
    }
  }
}
